import { takeEvery, select, put } from 'redux-saga/effects'
import {
  NOTIFICATIONS,
  NOTIFICATIONS_LOAD_MORE,
  NOTIFICATIONS_MARKED_READ,
  NOTIFICATIONS_SCROLL,
  NOTIFICATIONS_UNREAD_COUNT,
} from 'store/entities/notifications/actionTypes'
import {
  getNotificationsPendingGetNotificationsLoadMore,
  getNotificationsPagination,
  getNotificationsPendingGetNotifications,
  getNotificationsLoadedGetNotificationsLoadMore,
} from 'store/entities/notifications/selectors'
import {
  enableNotificationsGetPending,
  enableNotificationsLoadMorePending,
  notificationsLoadMore,
} from 'store/entities/notifications/actions'
import {
  LOAD_NOTIFICATIONS_EVENT,
  MARK_NOTIFICATIONS_READ_EVENT,
  NOTIFICATIONS_UNREAD_COUNT_EVENT,
} from 'app/constants/reactions'

export default function* getNotificationsSaga(params) {
  yield* [
    takeEvery(NOTIFICATIONS.GET.REQUEST, handleGetNotifications, params),
    takeEvery(NOTIFICATIONS_LOAD_MORE.GET.REQUEST, handleGetLoadMoreNotifications, params),
    takeEvery(NOTIFICATIONS_UNREAD_COUNT.GET.REQUEST, handleNotificationsUnreadCount, params),
    takeEvery(NOTIFICATIONS_MARKED_READ.GET.REQUEST, handleMarkNotificationsAsRead, params),
    takeEvery(NOTIFICATIONS_SCROLL, handleNotificationsScroll),
  ]
}

export function* handleGetNotifications(params) {
  const pending = yield select(getNotificationsPendingGetNotifications)
  if (!pending) {
    yield put(enableNotificationsGetPending)
    yield makeGetNotificationsRequest(params)
  }
}

export function* handleGetLoadMoreNotifications(params) {
  const pending = yield select(getNotificationsPendingGetNotificationsLoadMore)
  if (!pending) {
    yield put(enableNotificationsLoadMorePending)
    yield makeGetNotificationsRequest(params, true)
  }
}

export function* makeGetNotificationsRequest(params, isNext = false) {
  const recentPagination = yield select(getNotificationsPagination)
  const page = recentPagination.get('page') + isNext
  const limit = recentPagination.get('limit')

  params.socket.emit(LOAD_NOTIFICATIONS_EVENT, {
    page,
    limit,
    sort: 'createdAt',
    desc: 1,
  })
}

export function handleMarkNotificationsAsRead(params) {
  params.socket.emit(MARK_NOTIFICATIONS_READ_EVENT)
}

export function handleNotificationsUnreadCount(params) {
  params.socket.emit(NOTIFICATIONS_UNREAD_COUNT_EVENT)
}

export function* handleNotificationsScroll({ payload: { scrollTop, clientHeight, scrollHeight } }) {
  const loaded = yield select(getNotificationsLoadedGetNotificationsLoadMore)
  if (!loaded && scrollTop + clientHeight >= scrollHeight) {
    yield put(notificationsLoadMore.get.request())
  }
}
